
"use strict";

const disableTransitionOnResize = {
    initialized: false,
    init: function() {
        if (this.initialized) return;
        this.initialized = true;
        let resizeTimer;
        window.addEventListener("resize", () => {
        document.body.classList.add("disable-transition-on-resize");
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            document.body.classList.remove("disable-transition-on-resize");
        }, 400);
        });
    }
};

export default disableTransitionOnResize
